import StepBox from '@/components/demo/StepBox';
export default {
  components: {
    StepBox,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    step: {
      type: Number,
    },
    currentStep: {
      type: String,
    },
    stepNavigation: {
      type: Object,
    },
  },
  methods: {
    validated(payload) {
      this.$emit('validated', payload);
    },
  },
};
